<template>
  <div class="page-footer" @touchmove="onTouchMove($event)">
    <div
      class="btn"
      v-for="(item, index) in buttons"
      :class="[item.type ? item.type : '']"
      :style="{ flex: item.flex ? item.flex : 1 }"
      :key="index"
      @click="clickHandle(item)"
      v-click-feedback="feedbackMap(item.type)"
    >
      <!--  加载  -->
      <img :src="submitLoadingImg" alt="" v-if="item.loading" class="btn-loading" />
      <!-- 多选 -->
      <svg-icon :type="isChecked(item)" class="check-box-img" v-if="(item.type || '').includes('check-box')" />
      <!-- 普通左侧图标 -->
      <template v-if="!item.rightIcon && !(item.type || '').includes('check-box')">
        <img :src="item.icon" v-if="item.icon" class="img-icon" :class="{ 'has-text': item.name }" />
        <svg-icon :type="item.svgIcon" v-if="item.svgIcon" class="img-icon" :class="{ 'has-text': item.name }" />
      </template>
      <!-- 显示文案 -->
      <div v-if="item.name" class="text-wrap">
        <p class="title" :class="{ 'has-sub-title': item.subTitle }">{{ item.name }}</p>
        <p v-if="item.subTitle" class="sub-title">{{ item.subTitle }}</p>
      </div>
      <!-- 右侧图标信息 -->
      <template v-if="item.rightIcon && !(item.type || '').includes('check-box')">
        <img :src="item.icon" v-if="item.icon" class="img-icon" :class="{ 'has-text': item.name }" />
        <svg-icon :type="item.svgIcon" v-if="item.svgIcon" class="img-icon" :class="{ 'has-text': item.name }" />
      </template>
    </div>
  </div>
</template>
<script>
/**
 * @description 底部按钮组件
 * @param buttons Button[]
 *  Button
 *  {
 *      type: '',
 *      name: '',
 *      flex: '',
 *      icon: '',
 *  }
 * */
import submitLoadingImg from '@/assets/images/common/submit-loading-v2@3x.png';

export default {
  name: 'page-footer',
  props: ['buttons'],
  data() {
    return {
      submitLoadingImg,
    };
  },
  methods: {
    clickHandle(item) {
      if (item.type && ~item.type.indexOf('disabled')) {
        if (item.disabledTip) {
          this.$handPlugin.toast.show(item.disabledTip);
        }
        return !1;
      }
      this.$emit('menuClick', item);
    },
    isChecked(item) {
      return item.checked ? 'circle-check' : 'circle-un-check';
    },
    onTouchMove($e) {
      $e.preventDefault();
    },
    feedbackMap(type) {
      if (['primary', 'danger'].includes(type)) {
        return 'deep-filter';
      }
      return 'deep-background';
    },
  },
};
</script>
<style lang="scss">
@import '~assets/css/variable.scss';
.page-footer {
  height: px(120);
  &:before {
    background: #fff;
  }
  .btn {
    display: flex;
    position: relative;
    flex: 1;
    height: px(80);
    box-sizing: border-box;
    border-radius: px(12);
    color: $mainColor;
    font-size: px(30);
    align-items: center;
    justify-content: center;
    background: #fff;
    border: px(2) solid $mainColor;
    &.vertical {
      flex-flow: column;
      justify-content: inherit;
      line-height: px(26);
      .img-icon {
        width: 36px;
        height: 36px;
        margin-bottom: 4px;
        &.has-text {
          width: 36px;
          height: 36px;
          margin-bottom: 4px;
          margin-right: 0;
        }
      }
      &.check-box {
        .check-box-img {
          width: px(36);
          height: px(36);
          margin-bottom: px(12);
          font-size: 36px;
          color: $mainColor;
        }
      }
    }
    @-webkit-keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
      }
    }
    .text-wrap {
      .title {
        &.has-sub-title {
          color: #0a0f1e;
          line-height: px(34);
        }
      }
      .sub-title {
        font-size: px(28);
        color: #505564;
        margin-top: px(8);
        line-height: px(32);
      }
    }
    .btn-loading {
      position: absolute;
      width: px(32);
      height: px(32);
      left: px(28);
      -webkit-transform: rotate(360deg);
      animation: rotation 2s linear infinite;
      -moz-animation: rotation 2s linear infinite;
      -webkit-animation: rotation 2s linear infinite;
      -o-animation: rotation 2s linear infinite;
    }
    &.disabled {
      background: #d7dce6;
      color: #fff;
      border: px(2) solid #d7dce6;
    }
    &.default {
      color: $mainColor;
      border: px(2) solid $mainColor;
      background: #fff;
    }
    &.danger {
      background: #fff;
      color: #fa6478;
      border: px(2) solid #fa6478;
    }
    &.primary {
      border: px(2) solid $mainColor;
      background: $mainColor;
      color: #fff;
    }
    &.text {
      font-size: 32px;
      color: #2d2d2d;
      text-align: center;
      line-height: 44px;
      border: none;
    }
    &.check-box,
    &.check-box-column {
      justify-content: flex-start;
      padding: 0;
      border: none;
      color: #505564;
      .check-box-img {
        width: px(32);
        height: px(32);
        margin-right: px(10);
        font-size: 32px;
        color: $mainColor;
      }
      & + .btn {
        margin-left: 0;
      }
    }
    &.check-box-column {
      display: flex;
      flex-direction: column;
      .check-box-img {
        margin-right: 0;
      }
    }
    & ~ .btn {
      margin-left: px(20);
    }
    .img-icon {
      width: px(50);
      height: px(50);
      &.has-text {
        width: 28px;
        height: 28px;
        margin-right: 4px;
      }
    }
    &.no-border {
      border: none;
    }
  }
}
</style>
